import WixSDK from 'shared/utils/wix-sdk';


const uid = WixSDK.Utils.getInstanceValue('uid');
const instanceId = WixSDK.Utils.getInstanceId();
export const REFRESH_EVENT = 'refreshOnLoginEvents';

export function storeForReload(data) {
  WixSDK.PubSub.publish(REFRESH_EVENT, {
    uid,
    instanceId,
    stored: data,
  }, true);
}



// WEBPACK FOOTER //
// ./src/widget/utils/reload.js